import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import {
    TokensResponse,
    TokensResponseSchema,
} from "@modules/authentication/schemas/TokensResponseSchema";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { create } from "superstruct";

export class AuthApiService {
    public constructor(private readonly apiClient: ApiClientInterface) {}

    authWithProxy(params: {
        token: string | null;
        myshopifyDomain: string;
    }): Observable<TokensResponse> {
        return this.apiClient
            .post({
                url: "/auth/proxy",
                responseType: "json",
                contentType: "application/json",
                body: JSON.stringify({
                    token: params.token,
                }),
                queryParams: {
                    ...(params.token && { token: params.token }),
                    shop: params.myshopifyDomain,
                },
            })
            .pipe(
                map((value) => create(value.body, TokensResponseSchema)),
                map((result) => result)
            );
    }

    authWithSign(params: {
        shopifyCustomerId: number;
        signatureTimestamp: number;
        signature: string;
        token: string | null;
        myshopifyDomain: string;
    }): Observable<TokensResponse> {
        return this.apiClient
            .post({
                url: "/auth/signed",
                responseType: "json",
                contentType: "application/json",
                body: JSON.stringify(params),
                queryParams: {
                    ...(params.token && { token: params.token }),
                    shop: params.myshopifyDomain,
                },
            })
            .pipe(
                map((value) => create(value.body, TokensResponseSchema)),
                map((result) => result)
            );
    }
}
